import Music from "@components/Collection/artist/music";
import { useLocalSearchParams } from "expo-router";

const ArtistSongScreen = () => {
  const { artistId, songId } = useLocalSearchParams<{
    artistId: string;
    songId: string;
  }>();
  return <Music artistId={artistId} songId={songId} />;
};

export default ArtistSongScreen;
